import template from './termination_reason_component.html';
import tr from '../../lib/default-translator.js';

class TerminationReasonComponentViewModel
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.termination_reason = ko.observableArray();
		this.employment_status_code = ko.observableArray();
		this.employment_code = ko.observable();

		// PAGE LOAD
		let Termination = (config) => {
			this.data($.extend({
				resign_type: '',
				sort_order: ''
			}, config));

			ko.mapping.fromJS(this.data(), {}, this);
		};

		this.init();
	}

	async updateData()
	{
		let res = await Grape.fetches.getJSON('/api/record', {
			table: 'v_employment_status_codes',
			schema: 'savanna'
		});

		if (res.status == 'OK')
		{
			if (res.records)
				this.termination_reason(res.records);
		}
		else
			Grape.alerts.apiError(res);

		let res_emp_status = await Grape.fetches.getJSON('/api/record', {
			table: 'employment_status_code',
			schema: 'public'
		});

		if (res_emp_status.status == 'OK')
		{
			if (res.records)
			{
				res_emp_status.records.unshift({ code: null, description: 'None' });
				this.employment_status_code(res_emp_status.records);
			}
		}
		else
			Grape.alerts.apiError(res);
	};

	edit_termination_reason(v, e)
	{
		let view_row = $(e.currentTarget).parent().parent().parent();
		let edit_row = $(e.currentTarget).parent().parent().parent().next();

		this.employment_code(v.code); 

		view_row.hide();
		edit_row.show();
	};

	async delete_termination_reason(v, e)
	{
		let view_row = $(e.currentTarget).parent().parent().parent().parent().prev();
		let edit_row = $(e.currentTarget).parent().parent().parent();

		let data = ko.mapping.toJS(v);

		let response = await Grape.alerts.confirm({type: 'danger', title: tr('Delete Termination Reason?'), message: tr('Are you sure you want to delete this termination reason?')});

		if (response)
		{
			let res = await Grape.fetches.postJSON('/admin/termination_reason/delete', data);
			if (res.status == 'OK')
			{
				Grape.alerts.alert({type: 'success', message: tr('Successfully deleted termination reason'), title: tr('Success')});
				this.updateData();
				edit_row.hide();
			}
			else if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else
				Grape.alerts.alert({type: 'error', message: tr('Something went wrong...'), title: tr('Error')});
		} 
	};

	async save_termination_reason(v, e)
	{
		let view_row = $(e.currentTarget).parent().parent().prev();
		let edit_row = $(e.currentTarget).parent().parent();

		let data = ko.mapping.toJS(v);
		let selectedStatus = this.employment_status_code().find(item => item.code === this.employment_code());

		// Assign code and description
		data.code = selectedStatus.code;
		data.description = selectedStatus.description;

		let res = await Grape.fetches.postJSON('/admin/termination_reason/edit', data);
		if (res.status == 'OK')
		{
			Grape.alerts.alert({type: 'success', message: tr('Successfully saved termination reason.'), title: tr('Success')});
			edit_row.hide();
			this.updateData();
		}
		else if (res.status == 'ERROR')
		{
			Grape.alerts.apiError(res);
			this.updateData();
		}
		else if (res.error)
		{
			Grape.alerts.alert({type: 'error', message: res.message, title: tr('Error')});
			this.updateData();
		}
		else
			Grape.alerts.alert({type: 'error', message: tr('Something went wrong...'), title: tr('Error')});
	};

	add_termination_reason(data)
	{
		let termination_reason = data.termination_reason;
		termination_reason.unshift({ 'resign_type': '', 'description': null ,'sort_order': 1 });
		let row = $('#termination_reason_body > tr:first-child');

		row.hide();
		row.next().show();
	}

	cancel_save(v, e)
	{
		let view_row = $(e.currentTarget).parent().parent().prev();
		let edit_row = $(e.currentTarget).parent().parent();
		edit_row.hide();
		this.updateData();
	}

	init()
	{
		this.updateData();
	}
}

export default {
	name: 'termination_reason_component',
	viewModel: TerminationReasonComponentViewModel,
	module_type: 'ko',
	template: template,
	template_filename: 'translation/components/termination_reason_component'
};
